import { CenterTefl } from '../../../lib/types/models/center-tefl/center-tefl'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export interface UnassignTeflInput {
  id: number
  centerId: number
}

export async function unassignCenterTefl(input: UnassignTeflInput) {
  const { centerId, ...rest } = input

  return restApiClient
    .url(constructApiUrl(API.centers.unassignCenterTefl.url, { id: centerId }))
    .post<CenterTefl>({ ...rest })
}
